/**
 * Fund Display Service
 *
 * Handles presentation logic for fund data including formatting,
 * styling, and display text transformations.
 */

/**
 * Get CSS classes for fund status badge appearance
 */
export function getFundStatusAppearance(status: string): string {
  switch (status) {
    case 'investing':
    case 'harvesting':
      return 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300';
    case 'fundraising':
      return 'bg-slate-100 dark:bg-slate-800 text-slate-800 dark:text-slate-300';
    case 'setup':
      return 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300';
    case 'liquidated':
      return 'bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-300';
    default:
      return 'bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-300';
  }
}

/**
 * Get human-readable display name for fund types
 */
export function getFundTypeDisplayName(fundType: string): string {
  switch (fundType) {
    case 'main':
      return 'Main Fund';
    case 'opportunity':
      return 'Opportunity Fund';
    case 'feeder':
      return 'Feeder Fund';
    case 'master':
      return 'Master Fund';
    case 'aiv':
      return 'AIV';
    default:
      return fundType;
  }
}

/**
 * Get human-readable display name for fund status
 */
export function getFundStatusDisplayName(status: string): string {
  switch (status) {
    case 'setup':
      return 'Setup';
    case 'fundraising':
      return 'Fundraising';
    case 'investing':
      return 'Investing';
    case 'harvesting':
      return 'Harvesting';
    case 'liquidated':
      return 'Liquidated';
    default:
      return status;
  }
}
